import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

// will scroll to top of page on any route change
function ScrollToTop({ history }) {

  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo(0, 0);
    });
    return () => {
      unlisten();
    }
  }, []);

  return (null);
}

export default withRouter(ScrollToTop);
